// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gvEI7","footer":"styles_footer__1F-A7"};